import { FEATURE_FLAGS } from "@/constants/featureFlags";
import { checkPermissionForRelease } from "@/utilities/jobs/jobUtilities";
import { HeaderMenuAccessRule } from "./headerMenuConfig";

export type HeaderMenuAccessContext = {
  apiEnv: string;
  auth: {
    admin: boolean;
    isBtdUser: boolean;
  };
  featureFlags: Partial<Record<keyof typeof FEATURE_FLAGS, boolean>>;
};

const evaluateAccessRule = (rule: HeaderMenuAccessRule, context: HeaderMenuAccessContext): boolean => {
  switch (rule.type) {
    case "excludeApiEnvs":
      return !rule.envs.includes(context.apiEnv);
    case "featureFlag":
      return Boolean(context.featureFlags[rule.flag]);
    case "auth":
      return context.auth[rule.key as keyof typeof context.auth];
    case "releasePermission":
      return checkPermissionForRelease(context.auth.admin, context.apiEnv);
    default:
      return true;
  }
};

export const isHeaderMenuEntryVisible = (
  access: HeaderMenuAccessRule[] | undefined,
  context: HeaderMenuAccessContext
): boolean => {
  if (!access || access.length === 0) {
    return true;
  }

  return access.every((rule) => evaluateAccessRule(rule, context));
};
